import React from "react"
import pulseVideo from "../img/Engagement.webm"
import onaVideo from "../img/solution-ona.webm"
import feedbackVideo from "../img/Feedback.webm"
import pulseMp4 from "../img/Engagement.mp4"
import onaMp4 from "../img/solution-ona.mp4"
import feedbackMp4 from "../img/Feedback.mp4"
import performanceVideo from "../img/Performance.webm"
import performanceMp4 from "../img/Performance.mp4"
import pulse2Video from "../img/homepage_surveys.mp4"
import feedback2Video from "../img/homepage_feedback.mp4"
import { classNames } from "./utils"

const resources = {
  pulse: { webm: pulseVideo, mp4: pulseMp4 },
  ona: { webm: onaVideo, mp4: onaMp4 },
  feedback: { webm: feedbackVideo, mp4: feedbackMp4 },
  performance: { webm: performanceVideo, mp4: performanceMp4 },
  pulse2: { mp4: pulse2Video },
  feedback2: { mp4: feedback2Video },
}

const FeatureVideo = ({ className, feature }) => {
  const resource = resources[feature]
  return (
    <div
      className={classNames(
        "feature-video",
        feature === "ona" && "feature-video-ona",
        className
      )}
    >
      <video autoPlay muted loop playsInline>
        {resource.webm && (
          <source type="video/webm" src={resource.webm}></source>
        )}
        <source type="video/mp4" src={resource.mp4}></source>
      </video>
    </div>
  )
}

export default FeatureVideo
